export enum TourType {
  APP_LANDING_FIRST_VISIT = 'APP_LANDING_FIRST_VISIT',
  LIBRARY_FIRST_VISIT = 'LIBRARY_FIRST_VISIT',
  CHAT_FIRST_VISIT = 'CHAT_FIRST_VISIT',
}
